import { PButton, PText } from "@porsche-design-system/components-react"
import { useContext, useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { formMessages } from "src/common/form.messages"
import { commonMessages } from "src/common/messages/common.messages"
import { Modal } from "src/context/modal/Modal"
import { ModalContext } from "src/context/modal/ModalContext"
import type { ModalProps } from "src/context/modal/ModalProvider"
import { ButtonGroup } from "../../form/buttonGroup/ButtonGroup"
import { editableEquipmentListMessages } from "../editableEquipmentList/editableEquipmentList.messages"

export interface ConfirmEquipmentResetModalProps {
	onResetToFactoryEquipment: () => Promise<void>
}

export const ConfirmEquipmentResetModal = ({ id, modalProps }: ModalProps<ConfirmEquipmentResetModalProps>) => {
	const { hideModal } = useContext(ModalContext)
	const { formatMessage } = useIntl()
	const [isFactoryResetInProgress, setIsFactoryResetInProgress] = useState(false)

	return (
		<Modal id={id} heading={formatMessage(editableEquipmentListMessages.resetToFactoryEquipment)}>
			<PText>
				<FormattedMessage
					{...editableEquipmentListMessages.resetToFactoryEquipmentConfirmationText}
					values={{ linebreak: <br /> }}
				/>
			</PText>

			<ButtonGroup>
				<PButton
					onClick={async () => {
						setIsFactoryResetInProgress(true)
						await modalProps.onResetToFactoryEquipment()
						setIsFactoryResetInProgress(false)
						hideModal(id)
					}}
					loading={isFactoryResetInProgress}
				>
					<FormattedMessage {...commonMessages.yes} />
				</PButton>
				<PButton type="button" variant="secondary" onClick={() => hideModal(id)}>
					<FormattedMessage {...formMessages.cancel} />
				</PButton>
			</ButtonGroup>
		</Modal>
	)
}
